import React, { useRef } from 'react';
import { selectIsMobileMQ, selectActiveMQ } from 'core/modules/MediaQueries/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { selectFeatures, selectPageName } from 'core/selectors/app';
import { selectUserIsIdentified } from 'core/selectors/user';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import { useTriggerSectionIsViewedGaEvent } from 'core/hooks/useTriggerSectionIsViewedGaEvent';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import List from 'core/modules/Partials/List/List';

import orgConfig from 'org/configs/org.config';
import TestimonialsItem from './components/TestimonialsItem';
import config from './configs';
import { triggerTestimonialsIsViewed, triggerTestimonialsIsSwiped } from './actions';

import './Testimonials.scss';

function Testimonials({ forceUseCarousel = false }) {
  const testimonialsRef = useRef();
  const dispatch = useDispatch();
  const {
    testimonialsCopy, checkShouldUseCarousel, getSectionTitle, shouldUseRewardCountValue,
    checkShouldShowIconInCarousel, checkShouldShowIconInSlide, carousel,
  } = config;
  const { earnType } = orgConfig;
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const { rewardCount, avgRewardCount } = useSelector(selectFeatures);
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const pageName = useSelector(selectPageName);
  const isHomePage = pageName === 'h';

  // Some clients (e.g., SWA) should use avgRewardCount instead of rewardCount for the counter value
  const rewardCountToShow = shouldUseRewardCountValue ? rewardCount : avgRewardCount;
  const shouldUseCarousel = checkShouldUseCarousel(userIsIdentified, isMobileMQ) || forceUseCarousel;
  const sectionTitle = getSectionTitle(rewardCountToShow, earnType, userIsIdentified);

  const dispatchTriggerSectionIsViewed = () => dispatch(triggerTestimonialsIsViewed());
  useTriggerSectionIsViewedGaEvent(testimonialsRef, dispatchTriggerSectionIsViewed);

  const activeMQ = useSelector(selectActiveMQ);
  const shouldShowIconInCarousel = checkShouldShowIconInCarousel(activeMQ, userIsIdentified);
  const shouldShowIconInSlide = checkShouldShowIconInSlide(activeMQ, userIsIdentified);

  const onCarouselSettle = (event) => {
    const slideIndex = event.selectedScrollSnap() + 1;
    if (isHomePage && !userIsIdentified) {
      dispatch(triggerTestimonialsIsSwiped(slideIndex));
    }
  };

  return (
    <div
      className={`mn_testimonials ${shouldUseCarousel ? 'mn_carouselView' : 'mn_staticView'}`}
      ref={testimonialsRef}
    >
      <ContentWrap>
        <SectionTitle title={sectionTitle} />
        <div className="mn_testimonialsItems">
          {shouldShowIconInCarousel && <div className="mn_testimonialsIcon" />}
          <List shouldUseCarousel={shouldUseCarousel} options={carousel} onSettle={onCarouselSettle}>
            {testimonialsCopy.map(testimonialText => (
              <TestimonialsItem
                testimonialText={testimonialText}
                key={testimonialText}
                shouldShowIconInSlide={shouldShowIconInSlide}
              />
            ))}
          </List>
        </div>
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><Testimonials {...props} /></ComponentErrorBoundary>;
